<template>
  <div class="card mb-4">
    <div
      class="card-header d-flex justify-content-between align-items-center"
      :class="{ 'card-header--bb': isCollapsed }">
      <div class="card-title text-dark  ml-4" :class="{ 'collapsed': !isCollapsed }" v-on="$listeners">
        <font-awesome-icon class="mr-2" :icon="['fas', 'chevron-right']" v-if="!hideChevrons && !isCollapsed" />
        <font-awesome-icon class="mr-2" :icon="['fas', 'chevron-down']" v-if="!hideChevrons && isCollapsed" />
        <slot name="title" />
      </div>
      <div class="mx-1 mr-2">
        <slot name="buttons" />
      </div>
    </div>
    <div class="collapse" :class="{ 'show': isCollapsed }">
      <div class="card-body px-4 py-3"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionCard',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    hideChevrons: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0.4em !important;
}
.accordion.accordion-light .card {
  border: 1px solid #eeeef4 !important;
  box-shadow: 0 0 3px #eee;
}
.card-header--bb {
  border-bottom: 1px solid #eeeef4 !important;
  box-shadow: 0 0 3px #eee;
}
</style>
